import CityColorer from "../../lib/CityColorer";

const defaultStyle = {
  position: "relative", 
  minHeight: 70, 
  padding: 5, 
  borderTopColor: "#737373", borderTopWidth: 1, borderTopStyle: "solid", 
  borderBottomColor : "#737373", borderBottomWidth: 1, borderBottomStyle : "solid",  
  borderRightColor : "#333", borderRightWidth: 1, borderRightStyle : "solid",  
  borderLeftStyle: "solid", borderLeftWidth: 10, 
  backgroundColor: "rgb(230,230,230)"
}

const _styles = {
  day:      { ...defaultStyle, borderTopColor: "black", borderLeftColor: "black", marginTop : "6px", borderTopWidth: 2 },
  activity: { ...defaultStyle },
  expense:  { ...defaultStyle },
  hotel:    { ...defaultStyle },
  note:     { ...defaultStyle, borderLeftColor: "#ddcf66" },
  default:  defaultStyle,
  buttonGrp: { right: 0, top: 0, position: "absolute" }
}

const _colors = [ 
  "#00aba9", "#00fff5", "#1ba1e2", "#3cdbd3", "#77b6ea", "#7dce82", 
  "#95adb6", "#a200ff", "#b9e5ff", "#c1ffbc", "#cbb3bf", "#dbc7be", 
  "#dfb9ff", "#e8e288", "#f09609", "#f7b9ff", "#ff0097"
]

/**
 * generador de estilos
 * para actividades y ciudades: un backgroundColor por ciudad
 */

export const getStyle = (function gsClosure() {
  const cityColorer = new CityColorer()

  return (type, isDayHovered = false, cityKey, selected = false, isPlaceHolder = false, dragging = false ) => {
    if (type == "city" || type == "activity") {
      const color = cityColorer.get(cityKey)

      return {
        ...(_styles["activity"]), // city == activity, for now 
        ...{ 
          borderLeftColor: color, 
          backgroundColor: (
            selected || isPlaceHolder 
              ? "rgb(200, 210, 210)" 
              : isDayHovered && !dragging
                ? "rgb(220, 220, 255)" 
                : "rgb(230,230,230)" 
          )
        }
      }
    }
    else {
      return { 
        ...(_styles[type] || _styles.default),  
        ...{ 
          backgroundColor: (
            selected || isPlaceHolder
              ? "rgb(200, 210, 210)" 
              : isDayHovered && !dragging
                ? "rgb(220, 220, 255)" 
                : "rgb(230,230,230)" 
          )
        }
      }
    }
  }
})()
